export const searchObjects = (objects,term) => {

    return term == "" 
        ? objects 
        : objects.filter((o) => JSON.stringify(o).toLowerCase().indexOf(term.toLowerCase()) != -1)

    }